<!-- 积分商品详情- -->
<template>
    <div class="box">
        <div class="detail-module">
            <img mode="widthFix" class="bannerImg" :src="data.sharePoster" alt="" />
            <div class="banner-info">
                <div class="price font34 red flex" v-if="data.price > 1 && data.isAll != 1">
                    <div class="font48">{{ data.price }}</div>
                    <div class="font24">积分</div>
                </div>
                <div class="price font34 red flex" v-else-if="data.isAll == 1">
                    <div class="font48">1-{{ maxScore }}</div>
                    <div class="font24">积分</div>
                </div>
                <div class="title font34 black">{{ data.title }}</div>
                <div class="font24 gray">{{ data.description }}</div>
            </div>
            <div class="divider-box flex-row flex-x-center flex-y-center">
                <div style="height: 40px" class="flex flex-y-center">
                    <van-divider>产品详情</van-divider>
                </div>
            </div>
            <div class="fix-box flex-row flex-x-center flex-y-center" v-if="data.price > 1">
                <button class="fix-btn" @click="toExchange">立即兑换</button>
            </div>
        </div>
        <div class="imgs flex-1">
            <img v-for="(item, index) in detailData" :key="index" class="img" mode="widthFix" :src="item.data.url" alt="" />
        </div>
        <van-popup v-model="showVoucherPopup" round position="bottom" closeable class="popup">
            <div class="popup-box">
                <div class="popup-tit">请选择兑换的券面值</div>
                <div class="popup-inner-box">
                    <div class="flex flex-y-center">
                        <div class="Blacks font30">可兑积分：</div>
                        <div class="Red font26">{{ data.score || 0 }}</div>
                        <div class="all-btn font26" @click="allChange(data.score)">
                            全部兑换
                        </div>
                    </div>
                    <div class="flex flex-y-center">
                        <div class="Greys font28 margin-right mt-40 mb-40">自定义</div>
                        <div>
                            <van-stepper :integer="true" v-model="buyStepperNumber" class="num" :min="0" :max="maxCustomScore" input-width="45" @plus="stepperChange" @minus="stepperChange" @blur="stepperChange" />
                        </div>
                    </div>
                    <div class="flex-between flex-y-center">
                        <div v-for="(item, index) in fixedOptions" :key="index" :class="`events ${isFixedChecked(item.id) ? 'checked-events' : ''}`" @click="fixedTagClick(item)" :style="{
                            color: isFixedChecked(item.id) ? '#fff' : '#A0ACB5',
                            borderColor: isFixedChecked(item.id) ? 'transparent' : '#A0ACB5',
                        }">
                            {{ item.value }}
                        </div>
                    </div>
                </div>
                <div class="flex flex-y-center">
                    <div class="Blacks font28">消耗积分：</div>
                    <div class="Red font40 bold flex-1">{{ goodsPrice }}</div>
                    <div class="submit-btn font26" @click="toSubmit()">确认兑换</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast, Dialog } from "vant";

export default {
    name: "productDetailJoin",
    components: {},
    data() {
        return {
            info: {},
            data: {},
            detailData: [],
            bottom: 0,
            shareShow: false, // 分享的弹框
            shareData: {}, // 海报内容
            id: "",
            showVoucherPopup: false,
            fixedOptions: [
                { id: 1, value: "100" },
                { id: 2, value: "200" },
                { id: 3, value: "500" },
            ],
            fixedChecked: null,
            buyStepperNumber: 0, //数字输入框
            maxScore: 9999,
        };
    },
    mounted() {
        this.getDetail(this.$route.query.id);
    },
    computed: {
        maxCustomScore() {
            return Math.min(this.data.score, this.maxScore)
        },
        goodsPrice() {
            if (this.fixedChecked) {
                return this.fixedChecked.value
            }
            return this.buyStepperNumber
        }
    },
    methods: {
        isFixedChecked(id) {
            return this.fixedChecked?.id == id
        },
        // 商品详情
        getDetail(id) {
            return request({
                url: `/jm/goods/getGoodsDetail?goodsId=` + id,
                method: "get",
            })
                .then((res) => {
                    this.detailData = res.data.content;
                    this.data = res.data;
                })
                .catch((error) => {
                    Toast({ position: "top", message: error ?? "" });
                });
        },
        // 跳转确认兑换
        toExchange() {
            if (this.data.isAll == 1) {
                this.showVoucherPopup = true;
            } else {
                this.$store.commit("order/SET_ADDRESS_DETAIL", null);
                this.$router.push({
                    name: "exchangeOrderJoin",
                    query: { productDetail: JSON.stringify(this.data) },
                });
            }
        },
        // 自定义数字
        stepperChange() {
            this.fixedChecked = null
        },
        //全部兑换
        allChange(scoreNumber) {
            if (scoreNumber > this.maxScore) {
                this.buyStepperNumber = this.maxScore
            } else {
                this.buyStepperNumber = scoreNumber
            }
            this.fixedChecked = null
        },
        // 选择非自定义数字
        fixedTagClick(fixedItem) {
            if (this.fixedChecked?.id == fixedItem.id) {
                return this.fixedChecked = null
            }
            this.buyStepperNumber = 0
            this.fixedChecked = fixedItem
        },
        // 告知弹框
        openDialog() {
            Dialog.confirm({
                title: "兑换告知",
                message:
                    "每月兑换时间截止至当月15日，发货时间为当月下旬，代金券实时到账，超过当月兑换时间的订单将在下个月进行。",
            })
                .then(() => {
                    this.toBuy();
                })
                .catch(() => { });
        },
        // 万能券提交兑换
        toSubmit() {
            if (!this.fixedChecked && this.buyStepperNumber == 0) {
                Toast({ position: "top", message: "请选择兑换的券面值" });
            } else {
                this.openDialog();
            }
        },

        // 下单
        toBuy() {
            let obj2 = {
                goodsKey: this.data.id,
                extend: "积分兑换",
                goodsPrice: this.goodsPrice,
                orderFrom: "pos",
                number: 1,
            };
            request({
                url: `/jm/order/buy`,
                method: "post",
                data: obj2,
            })
                .then((res) => {
                    Toast({ position: "top", message: "兑换成功" });
                    this.showVoucherPopup = false;
                    this.$router.push({
                        name: "biRecordJoin",
                    });
                })
                .catch((error) => {
                    Toast({ position: "top", message: error ?? "" });
                });
        },
    },
};
</script>

<style scoped lang="less">
.box {
    height: 100%;
    overflow-y: auto;
}

.detail-module {
    display: flex;
    flex-direction: column;
    align-items: center;

    justify-content: flex-start;
}

.bannerImg {
    width: 750px;
    height: 708px;
    background: #ffffff;
}

.banner-info {
    width: 750px;
    height: 256px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px;
    box-sizing: border-box;
}

.banner-info>div {
    display: flex;
    align-items: baseline;
    padding-top: 20px;
}

.banner-info .price>div {
    float: left;
}

.banner-info .title {
    height: 80px;
    margin-bottom: 24px;
    align-items: center;
}

.red {
    color: #ee4c4c;
}

.black {
    color: #333f48;
}

.gray {
    color: #a0acb5;
}

.divider-box {
    width: 100%;
    background: #f5f6f5;
    height: 80px !important;
}

:deep(.van-divider) {
    margin: 0;
}

.fix-box {
    width: 750px;
    height: 120px;
    background: #ffffff;
    position: fixed;
    bottom: 0;
}

.fix-btn {
    width: 630px !important;
    height: 88px;
    background: #333f48;
    border-radius: 44px;
    color: #fff;
    font-size: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: normal;
}

.img {
    width: 750px;
    display: block;
}

.all-btn {
    color: #4375c9;
    margin-left: 20px;
}

.popup-box {
    padding: 50px 30px;
    height: 548px;

    .popup-tit {
        width: 100%;
        height: 48px;
        font-size: 34px;
        font-weight: 700;
        color: #35434c;
        margin-bottom: 20px;
    }

    .popup-inner-box {
        border-top: 1px solid #ebebeb;
        border-bottom: 1px solid #ebebeb;
        height: 308px;
        padding: 40px 0;
        margin-bottom: 25px;
    }

    .events {
        width: 212px;
        height: 60px;
        border-radius: 4px;
        line-height: 60px;
        padding: 0 30px;
        background-color: #fff;
        font-size: 26px;
        margin: 10px;
        text-align: center;
        color: #a0acb5;
        border: 1px solid transparent;
    }

    .events.checked-events {
        background: #2fd0d5;
    }

    .submit-btn {
        width: 220px;
        height: 70px;
        background: #333f48;
        border-radius: 40px;
        color: #fff;
        text-align: center;
        line-height: 70px;
    }
}

:deep(.van-stepper) {
    border: 1px solid #cccccc;
    height: 46px;
    border-radius: 4px;
}

:deep(.van-stepper__minus) {
    background-color: #f3f5f6;
    height: 42px;
    border-right: 1px solid #cccccc;
}

:deep(.van-stepper__input) {
    background-color: #fff;
    height: 42px;
}

:deep(.van-stepper__plus) {
    background-color: #f3f5f6;
    height: 42px;
    border-left: 1px solid #cccccc;
}

:deep(.van-stepper__plus::after) {
    height: 40%;
}

:deep(.van-stepper__plus::before) {
    width: 35%;
}

:deep(.van-stepper__minus::before) {
    width: 35%;
}
</style>
